import amplitude from 'amplitude-js';
import { getAllCookies } from 'common/bridges/cookies.bridge';
import ReactPixel from 'react-facebook-pixel';
import ReactGA from 'react-ga4';
import ym from 'react-yandex-metrika';
import YMInitializer from 'react-yandex-metrika/lib/init';
import routes from '../constants/routing.constants';
import { paramsToObject } from './common.utils';
import { log } from './logging.util';

let prevAmpEvent = '';
let ampIdentity = null;

const trackAmpEvent = (event) => {
  if (event !== prevAmpEvent) amplitude.getInstance().logEvent(event);
  prevAmpEvent = event;
};

export const initAmplitude = () => {
  amplitude.getInstance().init(process.env.REACT_APP_AMPLITUDE_ID, null, {
    includeReferrer: true,
    includeUtm: true,
  });
  ampIdentity = new amplitude.Identify();
};

const GA_UTM_TERMS = {
  referrer: 'referrer',
  ref: 'referrer',
  utm_campaign: 'campaignName',
  utm_medium: 'campaignMedium',
  utm_source: 'campaignSource',
  utm_term: 'campaignKeyword',
  utm_content: 'campaignContent',
};

export const initGA = (trackingID) => {
  const query = paramsToObject(new URLSearchParams(window.location.search));
  ReactGA.initialize(trackingID, {
    alwaysSendToDefaultTracker: true,
    gtagOptions: { cookieFlags: 'SameSite=None; Secure' }, // to use it in iframe
  });
  const cookies = { ...getAllCookies(), ...query };
  log(`all accepted cookies: ${JSON.stringify(cookies)}`);
  /* Providing utm terms manually to GA module */
  Object.entries(cookies).forEach(([key, val]) => {
    if (key in GA_UTM_TERMS) {
      ReactGA.set({ [GA_UTM_TERMS[key]]: val });
      log(`GA set: ${GA_UTM_TERMS[key]} ${val}`);
    }
  });
};

export const initYM = (id) => {
  YMInitializer([id], { webvisor: true }, '2');
};

export const initFB = (id) => {
  const options = {
    autoConfig: true, // set pixel's autoConfig. More info: https://developers.facebook.com/docs/facebook-pixel/advanced/
    debug: false,
  };
  ReactPixel.init(id, {}, options);
};

export const setAmpUserProperties = (props) => {
  amplitude.getInstance().setUserProperties(props);
};

export const setAmpSessionId = (id) => {
  ampIdentity.set('session', id);
};

export const setAmpUserId = (id) => {
  log(`setted amp userid: ${id}`);
  amplitude.getInstance().setUserId(id);
};

export const trackAnalyticEvent = (pathname) => {
  trackAmpEvent(`rwt-${pathname}`);
  ym('reachGoal', pathname);
  ReactGA.event({
    category: 'Frontend Event',
    action: pathname,
    label: 'Frontend Event',
  });
  ReactPixel.track(pathname);
};

export const clickTrack = (analyticEvent) => () => {
  trackAnalyticEvent(analyticEvent);
};

export const resetAnalytics = () => {
  amplitude.getInstance().setUserId(null);
  amplitude.getInstance().regenerateDeviceId();
};

export const getPathnameForAnalytics = () => {
  const route = window.location.pathname;
  let page = route.substring(1);
  if (route === routes.trading.path) {
    page = 'trading_main';
  } else if (route === routes.faq.path) {
    page = 'faq';
  } else if (route === routes.operations.path) {
    page = 'deposit_withdrawal';
  } else if (route === routes.profile.path) {
    page = 'profile';
  } else if (route === routes.accounts.path) {
    page = 'accounts';
  } else if (/accounts\/\d*\/\d*/g.test(route)) {
    page = 'account_history-statements';
  } else if (
    /accounts\/\d*\/\d*/g.test(route) &&
    (route.match(/\//g) || []).length === 2
  ) {
    page = 'account_history';
  } else if (route === routes.accountOpen) {
    page = 'open_account';
  }
  return page;
};

export const fbVisitPageTrack = () => {
  ReactPixel.pageView();
};

export const trackPageEvent = (event) => {
  trackAnalyticEvent(`${getPathnameForAnalytics()}-${event}`);
};

export const clickPageTrack = (analyticEvent) => () => {
  trackPageEvent(analyticEvent);
};

export const wrapPageOnClick = (fn, analyticEvent) => () => {
  trackPageEvent(analyticEvent);
  fn();
};
